import type { ImgHTMLAttributes } from 'react';
import { isTrustedImageUrl, resolveApiAssetUrl } from 'src/lib/utils/urls';

/** A link to an image that is not fetched automatically, showing its URL. */
export function UntrustedImageLink({ url }: { url: string }) {
  return (
    <a href={url} target="_blank" rel="noopener noreferrer nofollow" className="break-all">
      {url}
    </a>
  );
}

interface GuardedImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  /** The hast node react-markdown passes; dropped so it never reaches the DOM. */
  node?: unknown;
}

/**
 * A react-markdown `img` that renders only trusted image URLs.
 *
 * Any other URL is shown as a link, so rendering untrusted markdown never
 * makes a request to a host the author chose.
 */
export function GuardedImage({ src, node: _node, ...props }: GuardedImageProps) {
  if (typeof src !== 'string' || !src) return null;
  const resolvedSrc = resolveApiAssetUrl(src);
  if (!isTrustedImageUrl(resolvedSrc)) return <UntrustedImageLink url={resolvedSrc} />;
  return <img src={resolvedSrc} {...props} />;
}
